import React from 'react';
import { makeStyles } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grey[200],
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
  }
}));

// TODO: some <Details> have been commented out for now
//  readd once you decide how to style them
// TODO: how to style this]
//  likely add to field comps as help text
//  maybe bury in a popup or something
type DetailsProps = {
  children: React.ReactNode,
}

const Details = ({ children }: DetailsProps) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      {children}
    </Paper>
  );
}

export default Details;
